import { _ExportExcelData, IExcelExportColumnConfig, IExcelExportConfig, IExcelExportSheetConfig, IExportExcelReturns } from "./ExcelThings/Export/Export";


/** @deprecated */
export namespace ExcelThings {
    /** @deprecated */
    export type IColumnToExcelExportFileConfig<TData> = IExcelExportColumnConfig<TData>
    /** @deprecated */
    export type ISheetConfig<TData> = IExcelExportSheetConfig<TData>
    /** @deprecated */
    export type IConfigExcelExport<TData> = IExcelExportConfig<TData>


    /** @deprecated */
    export function _ExportData<T>(config: IConfigExcelExport<T>): IExportExcelReturns {
        return _ExportExcelData(config)
    }
}